import React from "react";
import styled from "styled-components";

const Loader = () => {
    return <Loading></Loading>;
};

export default Loader;

const Loading = styled.div`
    margin: 50px;
    margin: auto;
    width: 50px;
    height: 50px;
    border: 10px solid black;
    border-radius: 50%;
    border-top: white;
    border-left: white;
    animation-name: spinner;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    @keyframes spinner {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;
